import { render, staticRenderFns } from "./NewUniformRequest.vue?vue&type=template&id=444836f0&scoped=true"
import script from "./NewUniformRequest.vue?vue&type=script&lang=js"
export * from "./NewUniformRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444836f0",
  null
  
)

export default component.exports